import React, { useEffect, useState } from 'react'
import { dataTableRender } from '../components/functions'
import api from '../components/api'
import { useHistory } from 'react-router-dom'
import ModalDestaque from '../modals/destaque'
import ModalCarrosel from '../modals/carrosel'
import ModalMembro from '../modals/membro'

const Paginas = () => {

    const history = useHistory()

    var [paginas, setPaginas] = useState()
    var [destaques, setDestaques] = useState()
    var [destaque_id, setDestaque_id] = useState()
    var [carrosel, setCarrossel] = useState()
    var [slider_id, setSlider_id] = useState()

    var [membros, setMembros] = useState()
    var [membro_id, setMembro_id] = useState()


    


    function abrePagina(pagina_id) {

        history.push(`/Pagina/${pagina_id}`)

    }



    async function listaCarrossel() {

        await api.get('sliderListaTodos').then((result) => {

            //console.log(result.data)
            setSlider_id()

            setCarrossel(result.data.map((rs) => 

                <tr style={{ cursor: 'pointer'}} data-toggle="modal" onClick={() => setSlider_id(rs.slider_id)} data-target="#modalCarrosel">
                    <td>
                        <center>
                        {rs.ordem}
                        </center>
                    </td>
                    <td style={{ display: 'none'}}>
                        {rs.texto1}
                    </td>
                    <td style={{ display: 'none'}}>
                        {rs.texto2}
                    </td>
                    <td style={{ display: 'none'}}>
                        {rs.texto3}
                    </td>
                    <td>
                        <center>
                        {rs.publicado ? 'Sim' : 'Não'}
                        </center>
                    </td>

                </tr>

            ))

            dataTableRender('tabelaCarrosel')

        }).catch((err) => {

            console.log(err.response)

        })


    }


    async function listaMembros() {


        await api.get('membroListaTodos').then((result) => {

            //console.log(result.data)

            setMembros(result.data.map((rs) =>

                <tr style={{ cursor: 'pointer'}} onClick={() => setMembro_id(rs.membro_id)} data-toggle="modal" data-target="#modalMembro">
                    <td>
                        <center>
                        {rs.ordem}
                        </center>
                    </td>
                    <td>
                        {rs.identificacao}
                    </td>
                    <td>
                        <center>
                        {rs.publicado ? 'Sim' : 'Não'}
                        </center>
                    </td>
                </tr>
            
            ))

        })

        dataTableRender('tabelaMembros')

    }


    async function listaDestaques() {

        await api.get('destaqueListaTodos').then((result) => {

            setDestaque_id()

            setDestaques(result.data.map((rs) =>
            
                <tr style={{ cursor: 'pointer'}} onClick={() => setDestaque_id(rs.destaque_id)} data-toggle="modal" data-target="#modalDestaque">
                    <td>
                        {rs.ordem}
                    </td>
                    <td>
                        {rs.titulo}
                    </td>
                    <td>
                        {rs.descricao}
                    </td>
                    <td>
                        {rs.ad_upd}
                    </td>
                    <td>
                        {rs.ad_usr}
                    </td>
                </tr>
            
            ))

            dataTableRender('tabelaDestaques')

        }).catch((err) => {

            console.log(err.response)

        })

    }


    async function carregaDados() {

        api.get('paginasCategorias').then((result) => {

            //console.log(result.data)

            setPaginas(result.data.map((rs) => 
            
                <tr style={{ cursor: 'pointer'}} onClick={() => abrePagina(rs.pagina_id)}>
                    <td>
                        {rs.identificacao}
                    </td>
                    <td>
                        <center>
                        {rs.barraLateral ? 'Sim' : 'Não'}
                        </center>
                    </td>
                    <td>
                        {rs.alias}
                    </td>
                    <td>
                        <center>
                        {rs.dataAtualizacao}
                        </center>
                    </td>
                    <td>
                        <center>
                        &nbsp;
                        </center>
                    </td>
                    <td>
                        <center>
                        {rs.fixo ? 'Sim' : 'Não'}
                        </center>
                    </td>
                    
                </tr>
            ))

            dataTableRender('tabelaPaginas')


        }).catch((err) => {

            console.log(err.response)

        })

        

    }



    async function verificaPermissao() {


        if (sessionStorage.getItem('permPaginas') != 'true') {

            history.push('/')

        }


    }


    function verificaPermissao() {


    }


    useEffect(() => {

        verificaPermissao()
        carregaDados()
        
    }, [])



    return (

        <div>
             <div class='content-header'>
                <div class='header-icon'>
                    <i class='pe-7s-home'></i>
                </div>
                <div class='header-title'>
                    <h1>P&aacute;ginas e Conteúdos</h1>
                    <small>Administração</small>
                    
                </div>
            </div>





            <div class="row">

                
                <div class="col-sm-12">
                    


                    <ul className="nav nav-tabs">
                            <li className="active"><a href="#tab1" data-toggle="tab">Conte&uacute;dos</a></li>
                            <li ><a href="#tab2" data-toggle="tab" onClick={() => listaDestaques()}>Destaques página inicial</a></li>
                            <li ><a href="#tab3" data-toggle="tab" onClick={() => listaCarrossel()}>Banner Slider página inicial</a></li>
                            <li ><a href="#tab4" data-toggle="tab" onClick={() => listaMembros()}>Logo membros</a></li>
                            
                        </ul>
                        
                        <div class="tab-content">
                            <div class="tab-pane fade in active" id="tab1">
                                <div class="panel-body">


                                                                                                                
                                        <button type="button" onClick={() => history.push('/Pagina/Nova')} class="btn btn-info" >+ Nova página</button>&nbsp;
                                        <br/><br/>


                                        
                                        <div className="table-responsive">
                                            <table id="tabelaPaginas" className="table table-bordered table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Página</th>
                                                        <th><center>Barra lateral</center></th>
                                                        <th><center>Alias</center></th>
                                                        <th><center>Alterado em</center></th>
                                                        <th><center>Por</center></th>
                                                        <th><center>Página fixa</center></th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {paginas}
                                                    
                                                </tbody>
                                                
                                            </table>
                                        
                                        </div>

                                </div>

                            </div>
                            <div className="tab-pane fade in" id="tab2">
                                <div className="panel-body">


                                
                                        

                                        <div className="table-responsive">
                                            <table id="tabelaDestaques" className="table table-bordered table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Ordem</th>
                                                        <th><center>Título</center></th>
                                                        <th><center>Descrição</center></th>
                                                        <th><center>Alterado em</center></th>
                                                        <th><center>Por</center></th>
                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                    {destaques}
                                                    
                                                </tbody>
                                                
                                            </table>
                                        
                                        </div>

                                </div>

                            </div>

                            <div className="tab-pane fade in" id="tab3">
                                <div className="panel-body">

                                <button type="button" class="btn btn-success" data-toggle="modal" data-target="#modalCarrosel" onClick={() => setSlider_id()}>+ Adicionar</button>

                                <br/><br/>
                                        
                                <div className="table-responsive">
                                        <table id="tabelaCarrosel" className="table table-bordered table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th><center>Ordem</center></th>
                                                    <th style={{ display: 'none'}}><center>Texto #1</center></th>
                                                    <th style={{ display: 'none'}}><center>Texto #2</center></th>
                                                    <th style={{ display: 'none'}}><center>Texto #3</center></th>
                                                    <th><center>Publicado</center></th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {carrosel}
                                                
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>


                                </div>

                            </div>

                            <div className="tab-pane fade in" id="tab4">
                                <div className="panel-body">

                                <button type="button" class="btn btn-warning" data-toggle="modal" data-target="#modalMembro" onClick={() => setMembro_id()}>+ Adicionar</button>

                                <br/><br/>
                                        
                                <div className="table-responsive">
                                        <table id="tabelaMembros" className="table table-bordered table-striped table-hover">
                                            <thead>
                                                <tr>
                                                    <th><center>Ordem</center></th>
                                                    <th>Identificação</th>
                                                    <th><center>Publicado</center></th>
                                                    
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {membros}
                                                
                                            </tbody>
                                            
                                        </table>
                                    
                                    </div>


                                </div>

                            </div>

                        </div>
                    

                </div>
            </div>


            <ModalDestaque destaque_id={destaque_id} listaDestaques={listaDestaques} />   
            <ModalCarrosel listaCarrossel={listaCarrossel} slider_id={slider_id} />
            <ModalMembro membro_id={membro_id} listaMembros={listaMembros} />

        </div>

    )

}

export default Paginas